module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02-m-jp.c115a2c90f737d9f51c61559d5fc2dca.png";